import { render, staticRenderFns } from "./TipsInfo.vue?vue&type=template&id=37c42184&scoped=true&"
import script from "./TipsInfo.vue?vue&type=script&lang=js&"
export * from "./TipsInfo.vue?vue&type=script&lang=js&"
import style0 from "./TipsInfo.vue?vue&type=style&index=0&id=37c42184&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c42184",
  null
  
)

export default component.exports